import Chats from '@/features/chats'
import {
    listAgentTicketsQuery,
    listDeskTicketsQuery,
    listFinishedTicketsQuery,
    listPendingTicketsQuery,
} from '@/queries/ticket.query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/chats/')({
  component: Chats,
  head: () => ({
    meta: [
      {
        title: 'Chats | Wazai',
      },
    ],
  }),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listAgentTicketsQuery)
    await context.queryClient.ensureQueryData(listPendingTicketsQuery)
    await context.queryClient.ensureQueryData(listDeskTicketsQuery)
    await context.queryClient.ensureQueryData(listFinishedTicketsQuery)
  },
})
